import _ from "lodash";
import Ajax from "Pub/js/ajax";
import { opersignNameObj, colorObj, getObjNameByDatatype, opersignObj, getItemtypeByDatatype } from "../utilService";
import { langCheck } from "Pub/js/utils";
import { setCardSelect } from '../events';
import Notice from "Components/Notice";
import platform from 'Pub/js/platform';
const { getLangCode } = platform;

/**
 * 获取当前语种元数据字段显示名称多语信息
 * @param {String} refname
 * @param {Array} multiOptions
 * @returns
 */
function getCardLabel(refname, multiOptions) {
    let local = getLangCode('langCode');
    let ret = {};
    if (!multiOptions) {
        return { label: refname };
    }
    multiOptions.forEach(opt => {
        let { languageMain, index, languageCode } = opt;
        let itemKey = `label${index}`;
        ret[itemKey] = languageCode === local ? refname : '';
    });
    return ret;
}
export function addMetaItem({ selectedTreeNode, targetAreaID, dataRef, areaList, dropIndex }) {
    let cardList = [];
    let draggingNode = { props: { dataRef } };
    let targetArea = areaList.find(item => item && item.pk_area === targetAreaID);
    let { json, multiOptions } = this.props;
    let selectedNodes = _.isEmpty(dataRef) ? [] : [draggingNode];

    if (selectedTreeNode.length > 0) {
        selectedTreeNode.forEach(item => {
            if (item.props.dataRef.myUniqID !== dataRef.myUniqID) {
                selectedNodes.push(item)
            }
        })
    }

    _.forEach(selectedNodes, (item, index) => {
        const {
            myUniqID,
            datatype,
            refname,
            refcode,
            pid,
            refpk,
            isLeaf,
            modelname,
            length,
            notSearchAreaCode,
            proid,
            resid,
            readonly
        } = item.props.dataRef;
        let cardObj = {};

        let cardLabels = getCardLabel(refname, multiOptions);
        //查询区
        if (targetArea.areatype === "0") {
            //操作符编码
            const opersign = getObjNameByDatatype(
                datatype,
                opersignObj
            );
            //操作符名称
            const opersignname = getObjNameByDatatype(
                datatype,
                opersignNameObj()
            );
            cardObj = {
                pk_query_property: `newMetaData_${myUniqID}`,
                areaid: targetAreaID,
                datatype: datatype,
                code: myUniqID,
                // label: refname,
                ...cardLabels,
                metapath: myUniqID,
                isnotmeta: false,
                isuse: true,
                opersign: opersign ? opersign : "=@>@>=@<@<=@like@",
                opersignname: opersignname
                    ? opersignname
                    : langCheck(
                        "ZoneSetting-000001",
                        "pages",
                        json
                    ) /* 国际化处理： 等于@大于@大于等于@小于@小于等于@相似@*/,
                defaultvalue: "",
                isfixedcondition: false,
                required: false,
                disabled: false,
                visible: datatype !== "56",
                ismultiselectedenabled: false,
                isquerycondition: true,
                refname: datatype === "204" ? modelname : "-99",
                containlower: !isLeaf,
                ischeck: false,
                isbeyondorg: false,
                usefunc: datatype === "34",
                showtype: "1",
                returntype: "refpk",
                define1: "",
                define2: "",
                define3: "",
                define4: "",
                define5: "",
                itemtype: "input",
                myrefpk: refpk,
                visibleposition: "",
                tablecode: "",
                querytablename: "",
                maxlength: length //查询区新增元数据赋值
            };
        } else {
            //非查询区
            cardObj = {
                pk_query_property: `newMetaData_${myUniqID}`,
                areaid: targetAreaID,
                code: notSearchAreaCode ? notSearchAreaCode : myUniqID,
                datatype: datatype,
                // label: refname,
                ...cardLabels,
                metapath: myUniqID,
                color: colorObj() && colorObj()[0].value, //取常量中默认颜色
                isrevise: false,
                required: false,
                disabled: false,
                visible: datatype !== "56",
                maxlength: length,
                defaultvalue: "",
                hyperlinkflag: false, //超链接
                defaultvar: "",
                define1: "",
                define2: "",
                define3: "",
                itemtype: "input",
                myrefpk: refpk
            };
        }

        if (targetArea.areatype === "1") {
            //表单
            cardObj.colnum = "1";
            cardObj.isnextrow = false;
        }
        if (targetArea.areatype === "2") {
            //表格
            cardObj.width = "";
            cardObj.istotal = false;
        }
        //参照
        if (cardObj.datatype === "204") {
            cardObj.metaid = refpk;
            cardObj.iscode = false;
            cardObj.modelname = modelname;
        }
        //自定义项
        if (cardObj.datatype === "56") {
            cardObj.isdefined = true;
        }
        //小数或者金额
        if (cardObj.datatype === "31" || cardObj.datatype === "52") {
            cardObj.dataval = "2,,";
        }

        //组件类型
        cardObj.itemtype = getItemtypeByDatatype(
            cardObj.datatype
        );

        //新增了两个属性
        cardObj.proid = proid;
        cardObj.resid = resid;
        if (readonly === true) {
            cardObj.disabled = true;
        }

        cardList.push(cardObj);
    });

    //查询区&非查询区枚举类型需要添加默认dataval
    let ajaxDataForSelect = [];

    _.forEach(cardList, c => {
        if (c.datatype === "203") {
            console.log(c.label);
            ajaxDataForSelect.push(c.myrefpk);
        }
    });


    if (ajaxDataForSelect.length > 0) {
        Ajax({
            url: `/nccloud/platform/templet/getEnumValue.do`,
            info: {
                name: langCheck(
                    "ZoneSetting-000017",
                    "pages",
                    json
                ) /* 国际化处理： 单据模板设置*/,
                action: langCheck(
                    "ZoneSetting-000122",
                    "pages",
                    json
                ) /* 国际化处理： 下拉选项*/
            },
            data: ajaxDataForSelect,
            success: res => {
                if (res) {
                    let { data, success } = res.data;
                    if (success && data) {
                        _.forEach(data, d => {
                            _.forEach(cardList, c => {
                                _.forEach(d, d2 => {
                                    if (d2.id === c.myrefpk) {
                                        if (_.isEmpty(c.dataval)) {
                                            c.dataval = `${d2.name}=${d2.value
                                                }`;
                                        } else {
                                            c.dataval = `${c.dataval},${d2.name
                                                }=${d2.value}`;
                                        }
                                    }
                                });
                            });
                        });
                    }
                    setDataValForCard.call(this, { cardList, areaType: targetArea.areatype, targetAreaID, dropIndex });
                }
            }
        });
    } else {
        setDataValForCard.call(this, { cardList, areaType: targetArea.areatype, targetAreaID, dropIndex });
    }
}

function setDataValForCard({ cardList, areaType, targetAreaID, dropIndex }) {
    let { json } = this.props;
    // if (areaType !== "0") {
        let ajaxData = [];
        _.forEach(cardList, c => {
            if (c.datatype === "204") {
                ajaxData.push(c.modelname);
            }
        });
        if (ajaxData.length > 0) {
            Ajax({
                url: `/nccloud/platform/templet/getRefDefaultSel.do`,
                info: {
                    name: langCheck(
                        "ZoneSetting-000017",
                        "pages",
                        json
                    ) /* 国际化处理： 单据模板设置*/,
                    action: langCheck(
                        "ZoneSetting-000024",
                        "pages",
                        json
                    ) /* 国际化处理： 查询参照默认下拉选项*/
                },
                data: ajaxData,
                success: res => {
                    if (res) {
                        let { data, success } = res.data;
                        if (success && data) {
                            _.forEach(data, d => {
                                _.forEach(cardList, c => {
                                    if (d.name === c.modelname) {
                                        c.dataval = `${d.pk_refinfo
                                            },code=1`;
                                        c.refname = d.name;
                                        c.refcode = d.refpath;
                                    }
                                });
                            });
                        }
                        console.log('meta ajax');
                        cardList[0]
                            && setCardSelect.call(this, cardList[0]);
                        this.addCardFromMetaTree({ cardList, targetAreaID, dropIndex });
                    }
                }
            });
        } else {
            cardList[0] && setCardSelect.call(this, cardList[0]);
            this.addCardFromMetaTree({ cardList, targetAreaID, dropIndex });
        }
    // } else {
    //     cardList[0] && setCardSelect.call(this, cardList[0]);
    //     this.addCardFromMetaTree({ cardList, targetAreaID, dropIndex });
    // }
}

export function filterRepeatMeta(queryPropertyList, cardList) {
    let metaPool = {};
    let filteredList = [];
    let errorMsg = {};

    queryPropertyList.forEach(item => {
        metaPool[item.code] = item.label
    });

    cardList.forEach(item => {
        if (metaPool[item.code]) {
            errorMsg[item.code]
                ? errorMsg[item.code].repeat.push({ [item.code]: item.label })
                : errorMsg[item.code] = { 'label': metaPool[item.code], repeat: [{ [item.code]: item.label }] }
        } else {
            filteredList.push(item)
        }
    });

    filteredList.forEach(item => {
        if (metaPool[item.code] === undefined) {
            metaPool[item.code] = item.label
        } else {
            errorMsg[item.code]
                ? errorMsg[item.code].repeat.push({ [item.code]: item.label })
                : errorMsg[item.code] = { 'label': metaPool[item.code], repeat: [{ [item.code]: item.label }] }
        }
    });

    return {
        cardList: filteredList,
        errorMsg
    }
}

export function giveRepeatedTips(errorMsg, json) {
    let tip = [];
    let tipExist = langCheck("ZoneSetting-000279", "pages", json);
    let tipAddDisable = langCheck("ZoneSetting-000280", "pages", json);
    for (let [key, value] of Object.entries(errorMsg)) {
        let repeatText = value.repeat.map(item => `“${key} ${item[key]}”`).join('、');
        let text = `${tip.length + 1}. ${tipExist}“${key} ${value.label}”, ${tipAddDisable}${repeatText}`;
        tip.push(text)
    }

    Notice({ status: "warning", msg: tip.join('\n') });
}
